import React from 'react';
import { Container, Box, Typography, Paper } from '@mui/material';
import SectionHeader from './SectionHeader';

const HowItWorksSection = () => {
  const steps = [
    {
      number: "1",
      title: "Enter Any Business Name",
      description: "No account connections needed. Just enter any business name - yours, competitors, suppliers, or clients. We gather all data from public sources."
    },
    {
      number: "2",
      title: "AI Analyzes All Review Platforms",
      description: "Our AI automatically gathers and analyzes reviews from all major platforms. No manual work required."
    },
    {
      number: "3",
      title: "Get Quantitative Revenue Impact",
      description: "See exactly how customer experience issues affect ratings and revenue. Get specific actions ranked by business impact."
    }
  ];

  return (
    <Box sx={{ py: { xs: 6, md: 8 }, backgroundColor: '#ffffff' }}>
      <Container maxWidth="md">
        <SectionHeader 
          title="How It Works: 3 Simple Steps"
        />
        
        <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 3 }}>
          {steps.map((step, index) => (
            <Box 
              key={index}
              sx={{ 
                flexGrow: 1, 
                flexBasis: { xs: '100%', md: 'calc(33.333% - 16px)' }, 
                maxWidth: { xs: '100%', md: 'calc(33.333% - 16px)' }, 
                textAlign: 'center' 
              }}
            >
              <Paper elevation={0} sx={{ p: 3, height: '100%', backgroundColor: 'transparent' }}>
                <Typography variant="h1" sx={{ 
                  mb: 1.5, 
                  fontWeight: 800, 
                  color: 'primary.main', 
                  opacity: 0.3 
                }}>
                  {step.number}
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                  {step.title}
                </Typography>
                <Typography variant="body1" sx={{ color: '#546E7A' }}>
                  {step.description}
                </Typography>
              </Paper>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default HowItWorksSection; 